
import * as Comlink from "comlink";
import { ImportMap, TestReport } from "../types";

interface PreviewApi {
  initialize: () => Promise<void>;
  addSandboxScript: (scriptId: string, scriptContent: string, isModule: boolean) => Promise<void>;
  addPackagesAndImportMap: (scripts: string[], importMap: ImportMap) => Promise<void>;
  setPublicFiles: (files: Record<string, string>) => Promise<void>;
  reportBuildError: (error: string) => Promise<void>;
  runTests: () => Promise<TestReport>;
}

const api = {
  revealError: ({ fileName, lineNumber }: { fileName: string, lineNumber: number }) => {
    if (Messenger.onErrorReveal)
      Messenger.onErrorReveal({ fileName, lineNumber })
  }
}

Comlink.expose(api);

export class Messenger {
  public static onErrorReveal?: ({ fileName, lineNumber }: { fileName: string, lineNumber: number }) => void;

  private remoteApi: Comlink.Remote<PreviewApi>

  constructor(window: Window, targetOrigin: string) {
    const parentEndpoint = Comlink.windowEndpoint(window, globalThis, targetOrigin);
    this.remoteApi = Comlink.wrap<PreviewApi>(parentEndpoint);
  }

  public async initialize() {
    await this.remoteApi.initialize();
  }

  public destroy() {
    if (this.remoteApi)
      this.remoteApi[Comlink.releaseProxy]();
  }

  public async addSandboxScript(scriptId: string, scriptContent: string, isModule: boolean) {
    await this.remoteApi.addSandboxScript(scriptId, scriptContent, isModule);
  }

  public async addPackagesAndImportMap(scripts: string[], importMap: ImportMap) {
    await this.remoteApi.addPackagesAndImportMap(scripts, importMap);
  }

  public async setPublicFiles(files: Record<string, string>) {
    await this.remoteApi.setPublicFiles(files);
  }

  public async reportBuildError(error: string) {
    await this.remoteApi.reportBuildError(error);
  }

  public async runTests() {
    return await this.remoteApi.runTests();
  }
}
